import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../shared/store';
import { AlertMessage } from '../shared/components/AlertGroup/models';

export interface AdminLayout {
  pageTitle: string;
  sidebar: boolean;
  messages: AlertMessage[];
  payByUserAgreements: string[];
}

const initialState: AdminLayout = {
  pageTitle: null,
  sidebar: true,
  messages: [],
  payByUserAgreements: [],
};

export const adminLayoutSlice = createSlice({
  name: 'adminLayout',
  initialState,
  reducers: {
    setPageTitle: (state, { payload }) => ({
      ...state,
      pageTitle: payload,
    }),
    showSidebar: (state, { payload }) => ({
      ...state,
      sidebar: payload,
    }),
    setAlertMessages: (state, { payload }: { payload: AlertMessage[] }) => ({
      ...state,
      messages: payload,
    }),
    clearAlertMessages: (state) => ({
      ...state,
      messages: [],
    }),
    setPayByUserAgreements: (state, { payload }) => ({
      ...state,
      payByUserAgreements: payload,
    }),
  },
  extraReducers: () => {},
});

export const {
  setPageTitle,
  showSidebar,
  setAlertMessages,
  clearAlertMessages,
  setPayByUserAgreements,
} = adminLayoutSlice.actions;
export const adminLayoutSelector = (state: RootState) => state.adminLayout;
